import { Button, Tooltip } from '@ets/design-system';
import { useIntl } from 'react-intl';

type ResolveButtonProps = {
  onClick: () => void;
  testId: string;
  disabled: boolean;
  isSelected?: boolean;
};

const ResolveButton = ({ disabled, testId, onClick, isSelected }: ResolveButtonProps) => {
  const intl = useIntl();
  return (
    <Tooltip
      visible={!disabled}
      content={
        isSelected
          ? intl.formatMessage({ id: 'MARK_AS_UNRESOLVED' })
          : intl.formatMessage({ id: 'MARK_AS_RESOLVED' })
      }
      testId={`${testId}-resolve-button-tooltip`}
    >
      <Button
        variant="link"
        size="m"
        disabled={disabled}
        onClick={onClick}
        testId={`${testId}-resolve`}
        icon={{
          name: 'circle-check',
          prefix: isSelected ? 'fas' : 'far',
          color: isSelected ? 'primary' : 'neutral',
        }}
      />
    </Tooltip>
  );
};

export default ResolveButton;
